import React from 'react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ImageSlot } from '../components/ui/ImageSlot';
import { StarDivider } from '../components/ui/StarDivider';
import { Instructors } from '../components/home/Instructors';
import { StatsBand } from '../components/home/StatsBand';
import { CtaBand } from '../components/shared/CtaBand';
import { IMAGES } from '../data/images';
import { BOOKING_URL } from '../data/site';
const timeline = [{
  year: '2009',
  title: 'NRA Certified Instructor',
  body: 'Maggie earns her first NRA instructor certification.'
}, {
  year: '2010',
  title: 'Sheriff-approved CCW instruction',
  body: 'Homeland Personal Protection begins teaching Nevada CCW.'
}, {
  year: '2013',
  title: 'Women-only classes',
  body: 'Women-only classes taught by women launch.'
}, {
  year: '2014',
  title: 'NRA Training Counselor',
  body: 'Maggie becomes an NRA Training Counselor, training new instructors.'
}, {
  year: 'Today',
  title: '14,000+ students',
  body: 'About 50 classes a week, 7 days a week, with a vetted instructor team.'
}];
export function About() {
  return <>
      <Seo title="About HPP Training & CCW Maggie" description="Meet Maggie Mordaunt (CCW Maggie), Ken Ortega and the HPP team — Las Vegas defensive firearms instructors since 2010." data-id="element-583" data-mp="1yjdf4gu4ctid" />
      <PageHero title="Defense-only. Since day one." sub="The story behind Las Vegas’ trusted CCW academy." image={IMAGES.students} crumbs={[{
      label: 'About'
    }]} data-id="element-584" data-mp="2deb738lcvgyx">
        <ButtonLink href={BOOKING_URL} size="lg" data-id="element-585" data-mp="2masimcxmtgv7">
          Train With Us
        </ButtonLink>
      </PageHero>

      <section className="gutter section grid gap-14 bg-white lg:grid-cols-12" aria-labelledby="maggie-title" data-id="element-586" data-mp="2w75f1ikka8tn">
        <div className="lg:col-span-5" data-id="element-587" data-mp="2r8kne7jdkxgt">
          <ImageSlot image={IMAGES.maggie} className="aspect-[4/5] rounded-[4px] lg:sticky lg:top-[calc(var(--header-h)+2rem)]" data-id="element-588" data-mp="2r9lygc0e5jyj" />
        </div>
        <div className="lg:col-span-7" data-id="element-589" data-mp="1sw81fcr9zuuq">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-accent" data-id="element-590" data-mp="1sx9ka3ej9ln0">“CCW Maggie”</p>
          <SectionHeading id="maggie-title" title="Maggie Mordaunt" intro="Founder & Lead Instructor" data-id="element-591" data-mp="1xtrrd9xc5w2i" />
          <div className="t-lead mt-8 max-w-[52rem] space-y-6 text-ink" data-id="element-592" data-mp="22nceg6xe55mx">
            <p data-id="element-593" data-mp="27k2vawh0s59e">Maggie became an NRA-certified instructor in 2009 and an NRA Training Counselor in 2014 — the level that trains other instructors. Since then she has personally trained more than 14,000 students.</p>
            <p data-id="element-594" data-mp="2gmc33ekwlkj3">She is a wife and a mom first, and that shapes everything she teaches. HPP is defense-only: no range-day entertainment, no ego. Every drill exists because it could matter on the worst day of someone’s life.</p>
            <p data-id="element-595" data-mp="m9w2ouesh0m5">Maggie still takes courses every year from instructors across the country. In her words:</p>
          </div>
          <blockquote className="mt-8 border-l-4 border-accent pl-6 font-display text-[clamp(1.6rem,2.4vw,2.6rem)] font-semibold uppercase leading-tight text-navy" data-id="element-596" data-mp="jn3djkad2w4w">
            “To be a great instructor, you have to be a great student.”
          </blockquote>
          <div className="mt-14 grid gap-10 md:grid-cols-2" data-id="element-597" data-mp="9xtlu5jfjfhb">
            <div data-id="element-598" data-mp="4z8lm646gvsv">
              <ImageSlot image={IMAGES.ken} className="aspect-[4/3] rounded-[4px]" data-id="element-599" data-mp="4zs1lha9pa49" />
              <h3 className="t-h3 mt-5 text-navy" data-id="element-600" data-mp="12l68sgti5pb5">Ken Ortega</h3>
              <p className="text-steel" data-id="element-601" data-mp="xn4o5rgfhhxk">Owner & Lead Instructor</p>
              <p className="mt-3 leading-relaxed text-steel" data-id="element-602" data-mp="xnxn4695b355">Ken leads our defensive handgun, carbine and low light programs and is known for spotting — and fixing — a shooter’s fundamentals in minutes.</p>
            </div>
            <div data-id="element-603" data-mp="oosu1fgcs20d">
              <h3 className="t-h3 text-navy" data-id="element-604" data-mp="3de0m022myulc">Our mission</h3>
              <span className="red-rule mt-3" aria-hidden="true" data-id="element-605" data-mp="3dc62ms70jajd" />
              <p className="mt-4 leading-relaxed text-steel" data-id="element-606" data-mp="39bm9dzpk8r2i">
                To give every student — beginners, women, experienced shooters — the real-world skill, legal understanding and confidence to protect themselves and the people they love. Safely, responsibly and without intimidation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <StatsBand data-id="element-607" data-mp="w4ctqx2heg5n" />

      <section className="gutter section bg-mist" aria-labelledby="timeline-title" data-id="element-608" data-mp="w5xpur4g275m">
        <SectionHeading id="timeline-title" title="Our Timeline" data-id="element-609" data-mp="1jtyptbnk4f9f" />
        <ol className="relative mt-14 grid gap-8 md:grid-cols-5" data-id="element-610" data-mp="1jsnr3q8yxxp6">
          <span className="absolute left-0 right-0 top-[1.1rem] hidden h-px bg-navy/20 md:block" aria-hidden="true" data-id="element-611" data-mp="1ot1nuc54dl7w" />
          {timeline.map(t => <li key={t.year} className="relative border-l border-navy/20 pl-6 md:border-l-0 md:pl-0" data-id="element-612" data-mp="1ev433ymgy6k1">
              <span className="absolute -left-[5px] top-3 h-2.5 w-2.5 rounded-full bg-accent md:static md:mb-6 md:block md:h-3 md:w-3 md:ring-8 md:ring-mist" aria-hidden="true" data-id="element-613" data-mp="3vjhxsln2hzbx" />
              <p className="font-display text-4xl font-bold text-navy" data-id="element-614" data-mp="3s23mzp53xzwy">{t.year}</p>
              <h3 className="mt-2 font-display text-lg font-semibold uppercase text-navy" data-id="element-615" data-mp="3s46lkxkbt1da">{t.title}</h3>
              <p className="mt-1 text-steel" data-id="element-616" data-mp="3n5d6x1taz4bj">{t.body}</p>
            </li>)}
        </ol>
        <StarDivider tone="light" className="mt-16" data-id="element-617" data-mp="5sj72uqrekxw" />
      </section>

      <Instructors data-id="element-618" data-mp="wbz6wesyzdb" />
      <CtaBand data-id="element-619" data-mp="tprmwrwwjv3" />
    </>;
}